import React, { useContext } from 'react'

import { WappContext, withWapp } from 'wapplr-react/dist/common/Wapp'

import { Divider } from 'karrierhub-ui/dist/common/src/components/MenuItem'
import Typography from 'karrierhub-ui/dist/common/src/components/Typography'

import AppContext from '../../App/context'
import AccountContext from '../context'

import ChangeData from '../ChangeData'
import ChangeEmail from '../ChangeEmail'
import ChangePassword from '../ChangePassword'

import { getTitle } from '../utils'

import style from './style.css'

function ProfileSettings(props) {

    const context = useContext(WappContext)
    const appContext = useContext(AppContext)
    const accountContext = useContext(AccountContext)

    const { user } = accountContext

    const { wapp } = context

    wapp.styles.use(style)

    const SubmitProps = {
        fullWidth: false,
        color: 'tertiary'
    }

    return (
        <div className={style.profileSettings}>
            <div>
                <div className={style.title}>
                    <Typography variant={'h5'} weight={600}>
                        {getTitle({
                            user,
                            page: 'changedata',
                            titles: appContext.titles
                        })}
                    </Typography>
                </div>
                <ChangeData {...props} SubmitProps={SubmitProps} />
                <Divider className={style.divider} />
            </div>
            <div>
                <div className={style.title}>
                    <Typography variant={'h5'} weight={600}>
                        {getTitle({
                            user,
                            page: 'changeemail',
                            titles: appContext.titles
                        })}
                    </Typography>
                </div>
                <ChangeEmail {...props} SubmitProps={SubmitProps} />
                <Divider className={style.divider} />
            </div>
            <div>
                <div className={style.title}>
                    <Typography variant={'h5'} weight={600}>
                        {getTitle({
                            user,
                            page: 'changepassword',
                            titles: appContext.titles
                        })}
                    </Typography>
                </div>
                <ChangePassword {...props} SubmitProps={SubmitProps} />
            </div>
        </div>
    )
}

export default withWapp(ProfileSettings)
